import { useSelector } from '@xstate/react'
import { useReviewsWizard } from './ReviewsWizardProvider'
import { TypeSelection } from './TypeSelection/TypeSelection'
import { FileSelection } from './FileSelection/FileSelection'
import { StateId } from './machineTypes'
import { AlmanacFile, RecipientsSelectorValueType } from 'types'
import { useMemo } from 'react'
import { ReviewersSelection } from './ReviewersSelection/ReviewersSelection'
import { EmailValue } from 'components/ShareSheet/RecipientSelector/Types'
import { InviteEmails } from './InviteEmails/InviteEmails'
import { SuggestersSelection } from './SuggestersSelection/SuggestersSelection'
import { AllTemplates } from './ReviewTemplates/AllTemplates'
import { useCurrentWorkspaceId } from 'hooks/useCurrentWorkspaceId'
import { TemplateForm } from './TemplateForm/TemplateForm'
import { Modal, useModals } from 'almanac-ui/Modal'

interface ReviewsWizardModalProps {
  overrideFolder?: AlmanacFile | null
  onClose?: () => void
}

export const ReviewsWizardModal = ({ overrideFolder, onClose }: ReviewsWizardModalProps) => {
  const { closeAllModals } = useModals()

  const { service } = useReviewsWizard()
  const workspaceId = useCurrentWorkspaceId()
  const state = useSelector(service, (state) => state)
  const reviewers = useSelector(service, (state) => state.context.reviewers)
  const approvers = useSelector(service, (state) => state.context.approvers)
  const viewers = useSelector(service, (state) => state.context.viewers)
  const suggesters = useSelector(service, (state) => state.context.suggesters)
  const newEmails = useMemo(() => {
    const recipientsToInvite = [...reviewers, ...approvers, ...viewers].filter(
      ({ type }) => type === RecipientsSelectorValueType.Email,
    ) as EmailValue[]

    const suggestersToInvite = suggesters.filter(
      ({ type }) => type === RecipientsSelectorValueType.Email,
    ) as EmailValue[]

    return [...recipientsToInvite, ...suggestersToInvite].map(({ value }) => value)
  }, [reviewers, approvers, viewers, suggesters])
  return (
    <>
      <Modal.Root size="md" onClose={onClose} onPressOutside={onClose}>
        {(state.matches(StateId.TYPE_SELECTION) ||
          state.matches(StateId.TYPE_SELECTION_FETCHING_REVIEW_TYPE_CONFIG)) && <TypeSelection />}
        {(state.matches(StateId.REVIEWERS_SELECTION) ||
          state.matches(StateId.REVIEWERS_SELECTION_FETCHING_REVIEW_TYPE_CONFIG)) && (
          <ReviewersSelection
            newEmails={newEmails}
            isDisabled={state.matches(StateId.REVIEWERS_SELECTION_FETCHING_REVIEW_TYPE_CONFIG)}
          />
        )}
        {state.matches(StateId.INVITE_EMAILS) && <InviteEmails newEmails={newEmails} />}
        {state.matches(StateId.SUGGESTERS_SELECTION) && <SuggestersSelection newEmails={newEmails} />}
        {state.matches(StateId.ALL_TEMPLATES) && <AllTemplates workspaceId={workspaceId} />}
        {state.matches(StateId.TEMPLATE_FORM) && <TemplateForm workspaceId={workspaceId} />}
        {state.matches(StateId.FILE_SELECTION) && (
          <FileSelection overrideFolder={overrideFolder} onClose={closeAllModals} />
        )}
      </Modal.Root>
    </>
  )
}
